/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, MenuItem, TextField } from '@material-ui/core'
import { WidgetProps } from '@rjsf/core'
import { useTranslation } from 'react-i18next'
import { dashify } from 'utils/dashify'
import { NotInitializedAsEmptyString } from 'utils/IsNotInitialized'

export const SelectInput = (props: WidgetProps) => {
  const { t } = useTranslation('project')
  const {
    rawErrors,
    autofocus,
    formContext,
    options,
    schema,
    uiSchema,
    readonly,
    ...others
  } = props

  return (
    <TextField
      {...others}
      value={NotInitializedAsEmptyString(props.value) || ''}
      InputProps={{
        readOnly: readonly,
      }}
      select
      label={t(
        `project:ws-step-form-${dashify(
          uiSchema['ui:label-translation-key'] ||
            uiSchema['ui:label'] ||
            uiSchema['ui:title']
        )}`,
        uiSchema['ui:label'] || uiSchema['ui:title']
      )}
      variant="standard"
      onChange={(e) => props.onChange(e.target.value)}
      onBlur={(e) => props.onBlur(props.id, e.target.value)}
      onFocus={(e) => props.onFocus(props.id, e.target.value)}
      color="primary"
      error={Boolean(props.rawErrors?.length)}
      helperText={''}
      required={props.required}
      fullWidth
    >
      {props.schema['x-enumNames']?.map((name, index) => {
        if (index === 0) return null
        return (
          <MenuItem key={name} value={name}>
            {t(`project:${name}`, name)}
          </MenuItem>
        )
      })}
    </TextField>
  )
}
